"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageSidebarControls = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../utils/classFunctions");
const Icon_1 = require("../../../Icon");
require("./index.scss");
const className = 'page-sidebar-controls';
class PageSidebarControls extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.onResize = () => {
            if (window.innerWidth < 1561 && !document.documentElement.classList.contains('sidebar-collapsed')) {
                document.documentElement.className += ' ' + 'sidebar-collapsed';
            }
        };
        this.handleLogout = (event) => {
            this.props.handleLogout();
        };
    }
    static SidebarTrigger() {
        if (document && document.documentElement) {
            if (/\bsidebar-collapsed\b/.test(document.documentElement.className)) {
                document.documentElement.className = document.documentElement.className.replace(' sidebar-collapsed', '');
            }
            else {
                document.documentElement.className += ' ' + 'sidebar-collapsed';
            }
        }
    }
    componentDidMount() {
        window.addEventListener('resize', this.onResize);
        this.onResize();
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
    }
    render() {
        const { modificators } = this.props;
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("div", { onClick: PageSidebarControls.SidebarTrigger, role: 'button', className: `${className}__item` },
                react_1.default.createElement("div", { className: `${className}__icon ${className}__icon--trigger` },
                    react_1.default.createElement(Icon_1.Icon, { name: 'arrows-left' })),
                react_1.default.createElement("div", { className: `${className}__text` },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Page/Sidebar/Controls:Collapse', defaultMessage: 'Collapse' }))),
            react_1.default.createElement("div", { onClick: this.handleLogout, role: 'button', className: `${className}__item` },
                react_1.default.createElement("div", { className: `${className}__icon` },
                    react_1.default.createElement(Icon_1.Icon, { name: 'logout' })),
                react_1.default.createElement("div", { className: `${className}__text` },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Page/Sidebar/Controls:Logout', defaultMessage: 'Logout' })))));
    }
}
exports.PageSidebarControls = PageSidebarControls;
//# sourceMappingURL=index.js.map